export default {"src":"/_next/static/media/dcr.79565b3a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};